<template>
  <m-card2 :alt="content.title" :image="content.thumbnail">
    <m-a class="text-decoration-none" :href="contentLink">
      <h6>{{ content.title }}</h6>
    </m-a>
    <div class="text-left py-2">
      <span v-t="`content.card.more`"></span>
      <i class="bi bi-arrow-left d-inline-block"></i>
    </div>
  </m-card2>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard2 from '../../Cards/Card2'
import mA from '../../Tags/A'

export default {
  name: "ContentCard300",
  components: {mCard2, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  }
}
</script>

<style scoped>
.content-card-300 {
  height: 350px;
}
</style>